import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class BusinessPartnerService {
    constructor(private http: HttpClient) {}

    linkBusinessPartner(token: string): Observable<TokenLinkResponse> {
        return this.http.post<TokenLinkResponse>(`${environment.http.usersV2BaseUrl}users/bp-token/link`, {
            token,
        });
    }

    migrateToken(legacyToken: string, redirectUrl?: string): Observable<{ token: string }> {
        return this.http.post<{ token: string }>(`${environment.http.usersV2BaseUrl}bp-token/migrate-legacy`, {
            legacyToken,
            redirectUrl,
        });
    }
}

export interface LinkResponse {
    alreadyLinked?: boolean;
    linked?: boolean;
    mismatch?: 'owner' | 'iam';
    message: string;
}

export interface TokenLinkResponse {
    linked: boolean; // completion status
    redirectUrl: string; // redirectUrl from token data
}
